import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/Hero';
import CallToAction from '../../components/CallToAction';
import './ProjectPage.css';

// Import images
import socialHeroImage from '../../assets/images/social.jpg';

const SocialResponsibility = () => {
  return (
    <div className="project-page">
      <Helmet>
        <title>Sosyal Sorumluluk Projeleri | ProgenX</title>
        <meta name="description" content="ProgenX'in eğitim teknolojileri alanındaki sosyal sorumluluk projeleri. Öğrencilere ücretsiz yazılım ve eğitim desteği sağlıyoruz." />
        <meta name="keywords" content="sosyal sorumluluk, eğitim desteği, öğrenci projeleri, ücretsiz yazılım, toplumsal fayda" />
      </Helmet>

      <Hero 
        title="Sosyal Sorumluluk Projeleri" 
        backgroundImage={socialHeroImage}
      />

      <div className="project-content">
        <div className="container">
          <section className="project-overview">
            <h2>Eğitimde Fırsat Eşitliği İçin Çalışıyoruz</h2>
            <p>
              ProgenX olarak, teknolojinin herkes için erişilebilir olması gerektiğine inanıyoruz. 
              Bu yüzden eğitim teknolojileri alanındaki birikimimizi, geleceğin teknoloji liderleri 
              olacak öğrencilerle paylaşıyoruz. Dezavantajlı bölgelerdeki öğrencilere ücretsiz 
              eğitim desteği sağlayarak, eğitimde fırsat eşitliğine katkıda bulunuyoruz.
            </p>
          </section>

          <section className="project-features">
            <h3>Neler Yapıyoruz?</h3>
            <div className="features-grid">
              <div className="feature-item">
                <h4>HAVELSAN F5 Projesi</h4>
                <p>
                  Hatay Naim Atakaş Anadolu Lisesi ile işbirliği yaparak, öğrencilere eğitim 
                  teknolojileri alanındaki yazılım ürünümüzü ücretsiz olarak sunuyoruz. 
                  Öğrencilerin başarılarını takip ediyor, öğretmenlere eğitim veriyor, 
                  teknik destek sağlıyoruz.
                </p>
              </div>

              <div className="feature-item">
                <h4>Dezavantajlı Bölgelere Destek</h4>
                <p>
                  Teknoloji ve eğitim olanaklarına erişimi kısıtlı bölgelerdeki öğrencilere 
                  ücretsiz eğitim içerikleri sağlıyoruz. Öğretmenlere eğitim programları 
                  düzenliyor, teknoloji altyapı desteği veriyor, mentorluk hizmeti sunuyoruz.
                </p>
              </div>

              <div className="feature-item">
                <h4>Teknoloji Eğitimleri ve Atölyeler</h4>
                <p>
                  Öğrencilere kodlama, STEM, yapay zeka, robotik gibi alanlarda eğitimler 
                  veriyoruz. Atölye çalışmaları düzenleyerek, öğrencilerin teknoloji alanında 
                  kendilerini geliştirmelerine destek oluyoruz.
                </p>
              </div>

              <div className="feature-item">
                <h4>Geleceğe Yatırım</h4>
                <p>
                  Daha fazla okulla işbirliği yapmayı, online eğitim platformları kurmayı, 
                  burs programları başlatmayı planlıyoruz. Öğrencilere staj imkanları sunarak, 
                  kariyer mentorluğu yaparak geleceklerine yatırım yapıyoruz.
                </p>
              </div>
            </div>
          </section>

          <section className="project-benefits">
            <h3>Projelerimizin Etkileri</h3>
            <div className="benefits-grid">
              <div className="benefit-item">
                <h4>Her Öğrenciye Eşit Fırsat</h4>
                <p>Teknoloji ve eğitim olanaklarına erişimi kısıtlı öğrencilere ücretsiz 
                imkanlar sunarak, eğitimde fırsat eşitliğine katkıda bulunuyoruz. Her öğrencinin 
                potansiyelini keşfetmesine yardımcı oluyoruz.</p>
              </div>
              <div className="benefit-item">
                <h4>Geleceğin Teknoloji Liderlerini Yetiştiriyoruz</h4>
                <p>Öğrencilere teknoloji alanında eğitimler vererek, onların kendilerini 
                geliştirmelerine destek oluyoruz. Geleceğin teknoloji liderleri bugünün 
                öğrencileri arasından çıkacak.</p>
              </div>
              <div className="benefit-item">
                <h4>Topluma Değer Katıyoruz</h4>
                <p>Eğitim teknolojileri alanındaki birikimimizi toplum yararına kullanarak, 
                toplumsal gelişime katkıda bulunuyoruz. Teknolojiyi herkes için erişilebilir 
                hale getiriyoruz.</p>
              </div>
              <div className="benefit-item">
                <h4>Uzun Vadeli ve Sürdürülebilir</h4>
                <p>Sosyal sorumluluk projelerimiz tek seferlik değil, uzun vadeli ve 
                sürdürülebilir. Öğrencilerin sürekli gelişimini destekleyerek, kalıcı 
                etkiler yaratıyoruz.</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <CallToAction 
        title="Eğitimde Fırsat Eşitliği İçin Birlikte Çalışalım"
        subtitle="Sosyal sorumluluk projelerimize destek olarak, daha fazla öğrenciye ulaşmamıza yardımcı olun."
        buttonText="İletişime Geçin" 
        buttonLink="/iletisim" 
      />
    </div>
  );
};

export default SocialResponsibility; 